const parseInfo = () => {
  try {
    return JSON.parse(localStorage.getItem('info')) || {};
  } catch {
    return {};
  }
};

export const startNativeLiveLocation = () => {
  if (!window.ReactNativeWebView) return;

  const info = parseInfo();
  if (!info.token) return;

  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      data: {
        startLiveLocation: {
          token: info.token,
          refreshToken: info.refresh_token,
          baseUrl: process.env.REACT_APP_BASE_URL,
        },
      },
    })
  );
};

export const stopNativeLiveLocation = () => {
  if (!window.ReactNativeWebView) return;

  window.ReactNativeWebView.postMessage(
    JSON.stringify({ data: 'stopLiveLocation' })
  );
};
